module.exports = __webpack_public_path__ + "img/address.6317d03f.png";